import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
// import PartnerSearch from "./PartnerSearch";
import { Alert, AlertTitle, Pagination } from "@mui/material";
import { findAllLeadApplicationAction } from "../../actions/aplicationActions/applicationsAction";
import ApplicationsTable from "../Application/allLeadApplications/ApplicationsTable";
import PartnerSearch from "./PartnerSearch";
import DownloadExcel from "../extraComponents/DownloadExcel";
import { partnersLeadApplicationFindAction } from "../../actions/partnerAction/partnerAction";
import { successTrueMsgAction } from "../../actions/globalAction";
import usePrivilegeCheck from "../../constants/customHooks/UsePrivilegeCheck";
import { MainContainer } from "../content/content.element";
import HeadBreadcrumbs from "../breadcrumbs/breadcrumbs";
import DownloadPdf from "../extraComponents/DownloadPdf";
import PartnerApplicationTable from "../Application/allLeadApplications/PartnerApplicationTable";
import PartnerLeadSearch from "./PartnerLeadSearch";

// material Table
const columns = [
  {
    title: "Sl no",
    field: "sl"
  },
  {
    title: "Student name",
    field: "studentName",
    hidden: false
  },
  {
    title: "Email",
    field: "email",
    hidden: false
  },
  {
    title: "Mobile Number",
    field: "mobileNumber",
    hidden: false
  },
  {
    title: "University",
    field: "university",
    hidden: false
  },
  {
    title: "Passport",
    field: "passport",
    hidden: false
  },
  {
    title: "Country",
    field: "country",
    hidden: false
  },
  {
    title: "Course",
    field: "course",
    hidden: false
  },
  {
    title: "Partner Name",
    field: "partner",
    hidden: false
  },
  {
    title: "Assigned Staff",
    field: "assigned staff",
    hidden: false
  },
  {
    title: "Intake",
    field: "intake",
    hidden: false
  },
  {
    title: "status",
    field: "status",
    hidden: false
  },
  {
    title: "Action",
    field: "action",
    filtering: false
  },
  {
    title: "Details",
    field: "action",
    filtering: false
  }
];

function PartnersLeadApplication(props) {
  const dispatch = useDispatch();

  const {
    privilege,
    hasPrivilege,
    isCreateNewPartnerPrevilage,
    isChangeLeaderPrevilage,
    isApprovePrevilage,
    isUpdatePrevilage,
    isDeletePrevilage,
    isCommisionCategoryChangePrevilage
  } = usePrivilegeCheck();

  const [whichPage, setWhichPage] = useState(0);
  const callback = (index) => {
    setWhichPage(index);
  };

  const [data, setData] = useState([]);
  // const [applicationData, setApplicationData] = useState([]);
  const [applicationData, setApplicationData] = useState([]);
  const [filterPassData, setFilterPassData] = useState();
  const [columnName, setColumnName] = useState("");
  const [whichFilter, setwhichFilter] = useState();
  const [reset, setReset] = useState(false);
  const [paginationPageNumber, setPaginationPageNumber] = useState(1);
  const [leadId, setLeadId] = useState([]);
  const [ids, setIds] = useState([]);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // / Employee column Visibility
  const [showNameColumn, setShowNameColumn] = useState(false);
  const [showEmailColumn, setShowEmailColumn] = useState(false);
  const [showPhoneColumn, setShowPhoneColumn] = useState(false);
  const [showWhatsAppNumColumn, setShowWhatsAppNumColumn] = useState(false);
  const [showPrefferedColumn, setShowPrefferedColumn] = useState(false);
  const [showLeadSourceColumn, setShowLeadSourceColumn] = useState(false);
  const [showLeadTypeColumn, setShowLeadTypeColumn] = useState(false);
  const [showStatusColumn, setShowStatusColumn] = useState(false);
  const [showEducationColumn, setShowEducationColumn] = useState(false);
  const [showUniversityPlaceColumn, setShowUniversityPlaceColumn] =
    useState(false);
  const [selectedIds, setSelectedIds] = useState([]);


  let { applicationAllFindSuccess } = useSelector((state) => {
    return state.findAllLeadApplication;
  });

  let { teamLeadAssignEmployeeSuccess } = useSelector((state) => {
    return state.teamLeadAssignStaffChange;
  });

  let { successAlertMsgSuccess, successAlertMsgErr } = useSelector((state) => {
    return state.successTrueMsg;
  });

  let { leadOwnerSuccess } = useSelector((state) => {
    return state.leadOwnerChange;
  });

  useEffect(() => {
    if (applicationAllFindSuccess) {
      setData(applicationAllFindSuccess?.data);
      let mergedArray = applicationAllFindSuccess?.data?.map(item1 => {
        let match = applicationAllFindSuccess?.passportNumber?.find(item2 => item2?.leadId === item1?.leadId)
        return { ...item1, ...match };
      })

      setApplicationData(
        mergedArray?.map((item) => ({
          id: item.id,
          column1: item.lead?.firstName,
          column2: item?.lead?.email,
          column3: item?.lead?.mobileNumber,
          column4: item?.universityName,
          column5: item?.passportNumber,
          column6: item?.universityCountry,
          column7: item?.courseName,
          column8:
            item?.user !== null ? item?.lead?.partner?.name : "Not Assigned",
          column9:
            item?.UserTeamLeadStaff !== null
              ? item?.UserTeamLeadStaff?.firstName
              : "Not Assigned",
          column10: item?.intakeDate ? item.intakeDate : " ",
          column11: item.methodStatus,
          leadId: item.leadId,
          isDuplicate: item.lead?.isLeadDuplicate,
          applyMethod: item?.applyMethod,
        }))
      );
    }
  }, [applicationAllFindSuccess, page]);

  useEffect(() => {
    if (teamLeadAssignEmployeeSuccess && successAlertMsgSuccess) {
      Swal.fire("Added!", "Staff assigned successfully.", "success");
      dispatch(successTrueMsgAction(false));
    }
  }, [teamLeadAssignEmployeeSuccess, successAlertMsgSuccess]);

  useEffect(() => {
    dispatch(partnersLeadApplicationFindAction(page));
  }, [dispatch, page, teamLeadAssignEmployeeSuccess, leadOwnerSuccess]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    alert(event.target.value);
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1); // Reset page number when changing rows per page
  };

  const toggleNameColumn = (status, column) => {
    if (column === "name") {
      setColumnName(column);
      setShowNameColumn(status);
    }

    if (column === "email") {
      setColumnName(column);
      setShowEmailColumn(status);
    }

    if (column === "mobile") {
      setColumnName(column);
      setShowPhoneColumn(status);
    }

    if (column === "whatsAppNumber") {
      setColumnName(column);
      setShowWhatsAppNumColumn(status);
    }

    if (column === "prefferedCountry") {
      setColumnName(column);
      setShowPrefferedColumn(status);
    }
    if (column === "leadSource") {
      setColumnName(column);
      setShowLeadSourceColumn(status);
    }

    if (column === "leadType") {
      setColumnName(column);
      setShowLeadTypeColumn(status);
    }

    if (column === "status") {
      setColumnName(column);
      setShowStatusColumn(status);
    }

    if (column === "education") {
      setColumnName(column);
      setShowEducationColumn(status);
    }

    if (column === "universityPlace") {
      setColumnName(column);
      setShowUniversityPlaceColumn(status);
    }
  };

  // excel download
  const excelDownloadClick = () => {
    DownloadExcel(columns, data, "Partner_Managment");
  };

  const pdfDownloadClick = () => {
    DownloadPdf(columns, data, "Partner_Management", "Partner Lead Application Details")
  }

  // searching
  const searchHandleChange = (e) => {
    if (e.target.value !== "" && e.target.value !== " ") {
      setApplicationData(
        applicationData?.filter((item) => {
          const name = item.column1 ? item.column1.toLowerCase() : "";
          const email = item.column2 ? item.column2.toLowerCase() : "";
          const phone = item.column3 ? item.column3.toLowerCase() : "";
          const manager = item.column4 ? item.column4.toLowerCase() : "";
          const preferredCountry = item.column5
            ? item.column5.toLowerCase()
            : "";
          const leadSource = item.column6 ? item.column6.toLowerCase() : "";
          // const leadOwner = item.leadOwner ? item.leadOwner.toLowerCase() : "";
          // const status = item.status ? item.status.toLowerCase() : "";
          // const education = item.education ? item.education.toLowerCase() : "";

          // const leadCity = item.leadCity ? item.leadCity.toLowerCase() : "";
          // const leadBranch = item.branchMaster
          //   ? item.leadCity.toLowerCase()
          //   : "";

          // :lead?.branch_master?.branchName
          return (
            name.includes(e.target.value.toLowerCase()) ||
            phone.includes(e.target.value.toLowerCase()) ||
            manager.includes(e.target.value.toLowerCase()) ||
            email.includes(e.target.value.toLowerCase()) ||
            preferredCountry.includes(e.target.value.toLowerCase()) ||
            leadSource.includes(e.target.value.toLowerCase())
            // leadOwner.includes(e.target.value.toLowerCase()) ||
            // status.includes(e.target.value.toLowerCase()) ||
            // education.includes(e.target.value.toLowerCase()) ||
            // leadCity.includes(e.target.value.toLowerCase()) ||
            // leadBranch.includes(e.target.value.toLowerCase())
          );
        })
      );
    } else {
      setApplicationData(
        data.map((item) => ({
          id: item.id,
          column1: item.lead?.firstName,
          column2: item?.universityCountry,
          column3: item?.courseName,
          column4: item?.user !== null ? item?.user?.firstName : "Not Assigned",
          column5:
            item?.UserTeamLeadStaff !== null
              ? item?.UserTeamLeadStaff?.firstName
              : "Not Assigned",
          column6: item.intakeDate,
          column7: item.methodStatus,
          leadId: item.leadId
        }))
      );
    }
  };

  // cleare filter
  const handleResetData = (status) => {
    setwhichFilter(null);
    setFilterPassData(null);
    setReset(!reset);
    setwhichFilter(null);
    setFilterPassData(null);
    setPaginationPageNumber(1);
  };

  const handleDeleteClick = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!"
    }).then((result) => {
      if (result.isConfirmed) {
        // dispatch(deleteLeadAction(leadId));
      }
    });
  };

  const setIdsFunction = (leadsId) => {
    setLeadId(leadsId);
  };

  if (!hasPrivilege("Partner Lead") && privilege !== null) {
    return (
      <Alert severity="error">
        <AlertTitle>warning</AlertTitle>
        You don't have permission to access — <strong>this page.!</strong>
      </Alert>
    );
  }

  return (
    <>
      <PartnerLeadSearch
        columnVisibleHandler={toggleNameColumn}
        excelDownloadClick={excelDownloadClick}
        pdfDownloadClick={pdfDownloadClick}
        showNameColumn={showNameColumn}
        showEmailColumn={showEmailColumn}
        showPrefferedColumn={showPrefferedColumn}
        showPhoneColumn={showPhoneColumn}
        showWhatsAppNumColumn={showWhatsAppNumColumn}
        showLeadSourceColumn={showLeadSourceColumn}
        showLeadTypeColumn={showLeadTypeColumn}
        showStatusColumn={showStatusColumn}
        showEducationColumn={showEducationColumn}
        showUniversityPlaceColumn={showUniversityPlaceColumn}
        filterPassData={filterPassData ? filterPassData : null}
        whichFilter={whichFilter ? whichFilter : null}
        handleResetData={handleResetData}
        handleDeleteClick={handleDeleteClick}
        searchHandleChange={searchHandleChange}
        ids={ids}
        leadId={leadId}
        component="application"
        selectedIds={selectedIds}
      // noAction={true}
      />
      <PartnerApplicationTable
        columns={columns}
        data={applicationData}
        setIdsFunction={setIdsFunction}
        component="partnerapplication"
        subMenu="Partner Lead"
        paginationPageNumber={applicationAllFindSuccess?.currentPage}
        pagiantionEntry={applicationAllFindSuccess?.totalPages}
        setSelectedLeadIds={setSelectedIds}
      />

      {/* <TablePagination
        rowsPerPageOptions={[10, 25, 50, 100]} // Customize the rows per page options as needed
        component="div"
        count={applicationData.length} // Total number of rows
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      /> */}

      <Pagination
        sx={{
          mt: "28px",
          "& .Mui-selected": {
            backgroundColor: "#f81b82 !important",
            color: "#fff"
          },
          "& .MuiPagination-ul": {
            justifyContent: "end"
          }
        }}
        rowsPerPageOptions={[10, 25, 50, 100]} // Customize the rows per page options as needed
        component="div"
        count={applicationAllFindSuccess?.totalPages} // Total number of rows
        rowsPerPage={applicationAllFindSuccess?.currentPage}
        page={page}
        onChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </>
  );
}

export default PartnersLeadApplication;
